import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import axios from "axios";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  AuthReducer,
  ActivateUserReducer,
  DeleteAssReducer,
} from "./Redux/Reducers/AuthReducer";
import {
  OrgsReduer,
  MyOrgReduer,
  GetOrgByIdReducer,
  EditOrgReducer,
  addOrgReducer,
  getEventsByOrgIdReducer,
} from "./Redux/Reducers/OrgsReducer";
import {
  eventsReducer,
  eventByIdReducer,
  addEventReducer,
  editEventReducer,
  deleteEventReducer,
  getEventAdminReducer,
} from "./Redux/Reducers/EventsReducer";

import {
  endEventReducer,
  eventOccReducer,
  joinEventReducer,
} from "./Redux/Reducers/EventOccReducer";

import { commonActionsReducer } from "./Redux/Reducers/CommonReducer";
import {
  addBookingReducer,
  getSingleBookingReducer,
  getUsersBookingsReducer,
} from "./Redux/Reducers/BookingsReducer";
import {
  addStudentReducer,
  AssociationsReducer,
  updateStudentReducer,
} from "./Redux/Reducers/UsersReducer";
import { SearchReducer } from "./Redux/Reducers/SearchReducer";
import { AppDataReducer, getMySchoolReducer } from "./Redux/Reducers/AppData";
import { StatsReducer } from "./Redux/Reducers/UserStatsReducers";

import { SchoolNewsReducer } from "./Redux/Reducers/SchoolDataReducer";
import { RelationsReducer } from "./Redux/Reducers/RelationsReducer";
import { AdminReducer } from "./Redux/Reducers/AdminReducer";
import OrgAssociationReducer from "./Redux/Reducers/OrgAssociationReducer";
import SchoolStudentReducer from "./Redux/Reducers/SchoolStudentReducer";
import SchoolReportsReducer from "./Redux/Reducers/SchoolReports";
import SchoolBulkManageStudentsReducer from "./Redux/Reducers/SchoolBulkManageStudentsReducer";

const appReducer = combineReducers({
  userInfo: AuthReducer,
  appData: AppDataReducer,
  mySchool: getMySchoolReducer,
  activateUser: ActivateUserReducer,
  DeleteAss: DeleteAssReducer,
  updateStudent: updateStudentReducer,
  //SCHOOLS
  schoolReport: SchoolReportsReducer,
  //ORGS
  orgs: OrgsReduer,
  orgById: GetOrgByIdReducer,
  myOrg: MyOrgReduer,
  orgAssociations: OrgAssociationReducer,
  editOrg: EditOrgReducer,
  addOrg: addOrgReducer,
  //ORG/EVENTS
  orgEvents: getEventsByOrgIdReducer,
  //EVENTS
  events: eventsReducer,
  eventById: eventByIdReducer,
  addEvent: addEventReducer,
  editEvent: editEventReducer,
  deleteEvent: deleteEventReducer,
  eventAdmin: getEventAdminReducer,
  //Event OCC
  occData: eventOccReducer,
  joinEvent: joinEventReducer,
  endEvent: endEventReducer,

  //BOOKINGS
  addBooking: addBookingReducer,
  userBookings: getUsersBookingsReducer,
  singleBooking: getSingleBookingReducer,

  //SCHOOL DATA
  SchoolBulk: SchoolBulkManageStudentsReducer,
  schoolData: SchoolNewsReducer,
  schoolStudents: SchoolStudentReducer,

  //STATS

  stats: StatsReducer,

  //NOTIFICATIONS now handled by React Query (src/Hooks/useNotifications.js)
  //COMMON
  common: commonActionsReducer,
  associations: AssociationsReducer,
  search: SearchReducer,
  AddStudent: addStudentReducer,

  Relations: RelationsReducer,

  // ADMIN PANEL
  AdminData: AdminReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const middleware = [thunk];

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : { token: null };

const initialState = { userInfo: userInfoFromStorage };

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware)),
);
// Force logout on any 401 while a session is active
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && store.getState().userInfo?.token) {
      localStorage.removeItem("userInfo");
      store.dispatch({ type: "LOGOUT" });
    }
    return Promise.reject(error);
  }
);

export default store;
